export const webviewBlocks = {
  mobile: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'webviewMasthead',
            className: 'mb-2.5 u-center',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    articleTaboola: {
      ads: [
        {
          componentInfo: {
            type: 'Taboola',
            targeting: 'article',
            mode: 'infinite',
          },
        },
      ],
    },
    icerikArasiTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'webviewIcerikArasiTop',
            class: 'u-center sm:hidden w-full',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'u-center sm:hidden w-full',
          },
        },
      ],
    },
    icerikArasiBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'webviewIcerikArasiBottom',
            class: 'u-center sm:hidden w-full',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'u-center sm:hidden w-full',
          },
        },
      ],
    },
  },
};
